export default __webpack_public_path__ + "static/media/bidifylogo.09d746ac.png";